export default __webpack_public_path__ + "/dist/images/marketplace_active.svg";